import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Box } from 'UIKit/Grid';
import {
  fetchOlimpicRating,
  REQUEST_GET_OLIMPIC_RATING,
} from '@/modules/Olimpic';

import OlimpicTable from 'sama_global/components/OlimpicTable';
import { useSnackbarListener } from 'sama_global/utils/hooks/snackbar';
import { useLoadbar } from 'sama_global/utils/hooks/loadbar';

const Rating = ({ getRating, requests, olimpic }) => {
  const id = olimpic?._id;

  useEffect(() => {
    if (id) getRating(id);
  }, [id]);

  const request = requests[REQUEST_GET_OLIMPIC_RATING];

  useSnackbarListener(request?.errorMessage);
  useLoadbar(REQUEST_GET_OLIMPIC_RATING);

  return (
    <Box>
      {request && <OlimpicTable title="PUBLIC_RATING" data={request.data} />}
    </Box>
  );
};

Rating.propTypes = {
  getRating: PropTypes.func.isRequired,
  requests: PropTypes.object.isRequired,
  olimpic: PropTypes.object.isRequired,
};

const mapStateToProps = state => ({
  requests: state.requests,
  olimpic: state.olimpic.sama,
});

const mapDispatchToProps = dispatch => ({
  getRating(id) {
    dispatch(fetchOlimpicRating(id));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Rating);
